import styled from "styled-components";

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto; /* permite rolar horizontalmente se precisar */
  margin-top: 1rem;

  /* esconde scrollbar no Chrome e Safari */
  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }
`;

export const TabletSelect = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 600px; /* força o scroll quando a tela for menor */

  th,
  td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    white-space: nowrap; /* impede quebra de linha */
  }

  th {
    background-color: #f5f5f5;
    font-weight: 500;
    font-size: 0.9rem;
    color: #333;
    position: sticky;
    top: 0; /* mantém o header fixo no topo */
    z-index: 2;
  }

  tr:hover {
    background-color: #f9f9f9;
  }

  .action-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    margin: 0 2px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;

    &:hover {
      background-color: #e0e0e0;
    }
  }
`;

export const RowNone = styled.div`
  text-align: center;
  padding: 2rem;
  color: #999;
  font-size: 0.9rem;
`;

export const ContainerSubtitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;

  h3 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 500;
    color: #333;
  }

  .action-button {
    background: #f5f5f5;
    color: #333;
    border: 1px solid #e0e0e0;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.9rem;
    transition: background-color 0.2s, border-color 0.2s;

    &:hover {
      background: #e0e0e0;
      border-color: #ccc;
    }
  }
`;
